export default class AuthTokenRequestDto {
	public refreshToken = '';
	public redirectUri = '';
	public code = '';

	public constructor(init?: Partial<AuthTokenRequestDto>) {
        Object.assign(this, init);
    }
}